'use strict';

var _ = require('lodash');
var CalibrationAnalysisPanelController = function CalibrationAnalysisPanelController($scope, constants, csvService, momentService, userSecureService, calibrationAnalysisConstants, systemStatusCommonRenderer, userPreferencesService) {
  $scope.screen = constants.CALIBRATION_ANALYSIS_SCREEN;
  $scope.gridId = constants.DEMAND_SHARES_GRID;
  $scope.mode = constants.DEMAND_SHARES_MODE;
  $scope.customRenderers = systemStatusCommonRenderer;
  $scope.isToolbarVisible = userPreferencesService.getUserSettingComponent('onlineLogitCalibrationExpansion') ? userPreferencesService.getUserSettingComponent('onlineLogitCalibrationExpansion') : false;
  $scope.reviewButtonEnabled = false;
  $scope.newCalibrationAnalysis = {};
  $scope.screenState = {
    searchResultMarkets: [],
    newPageVisible: false,
    reviewPageVisible: false
  };
  $scope.reviewDemandShare = function () {
    $scope.screenState.newPageVisible = false;
    $scope.screenState.reviewPageVisible = true;
  };
  $scope.createNewDemandShares = function () {
    $scope.screenState.newPageVisible = true;
    $scope.screenState.reviewPageVisible = false;
    $scope.newCalibrationAnalysis.dateRangeFrom = momentService.now(momentService.FIELD.DEPARTURE_DATE).subtract(calibrationAnalysisConstants.DEFAULT_DATE_FROM, 'day');
    $scope.newCalibrationAnalysis.dateRangeTo = momentService.now(momentService.FIELD.DEPARTURE_DATE).subtract(calibrationAnalysisConstants.DEFAULT_DATE_TO, 'day');
    $scope.newCalibrationAnalysis.shareReviewDateRangeFrom = momentService.now(momentService.FIELD.DEPARTURE_DATE).subtract(calibrationAnalysisConstants.DEFAULT_DATE_FROM, 'day');
    $scope.newCalibrationAnalysis.shareReviewDateRangeTo = momentService.now(momentService.FIELD.DEPARTURE_DATE).subtract(calibrationAnalysisConstants.DEFAULT_DATE_TO, 'day');
    $scope.newCalibrationAnalysis.metric = calibrationAnalysisConstants.UNTRUNCATED_DEMAND_METRIC;
    $scope.newCalibrationAnalysis.calibrationName = '';
  };
  $scope.makeExportToCsv = function (visibleRows) {
    csvService.exportToCSV(visibleRows);
  };
  $scope.hasCreationPermission = function () {
    return userSecureService.hasAuthorization('calibration-analysis', 'write');
  };
  $scope.submitNewCalibrationAnalysis = function () {
    $scope.newCalibrationAnalysis.visible = false;
    $scope.$broadcast('grid:clearAndLoadData:' + $scope.gridId);
  };
  function isReviewButtonEnabled(selectedCalibration) {
    return selectedCalibration.calibrationStatus === calibrationAnalysisConstants.CALIBRATION_STATUSES.CREATED || !_.isUndefined(selectedCalibration.active);
  }
  $scope.onCalibrationRowSelectionChange = function (event, selectedRows, gridId) {
    if (gridId !== 'demand-shares' || selectedRows.length !== 1) {
      $scope.reviewButtonEnabled = false;
      return;
    }
    $scope.selectedCalibrationData = selectedRows[0];
    $scope.reviewButtonEnabled = isReviewButtonEnabled(selectedRows[0]);
  };
  $scope.displayAndRefreshCalibrationAnalysis = function () {
    $scope.screenState.newPageVisible = false;
    $scope.screenState.reviewPageVisible = false;
    $scope.$broadcast('grid:clearAndLoadData:' + $scope.gridId);
  };
  $scope.toggleToolbar = function () {
    $scope.isToolbarVisible = !$scope.isToolbarVisible;
  };
};
CalibrationAnalysisPanelController.$inject = ['$scope', 'DataRetrieverConstantsService', 'DemandSharesCSVService', 'MomentService', 'UserSecureService', 'CalibrationAnalysisConstants', 'SystemStatusCommonRendererFactory', 'UserPreferencesService'];
module.exports = CalibrationAnalysisPanelController;